import { getLocalStorage, setLocalStorage } from '../utils/local-storage';
import * as tjCookie from '../tj-storage';
/**
 * 获取环境平台
 * @returns { isTujiaAppEnv, isCtripAppEnv, isQunarAppEnv, isMayiAppEnv, isElongAppEnv, isJdAppEnv, isWxEnv, isAliEnv, isWxMpEnv, isAliMpEnv, isBaiduMpEnv, isTouTiaoMpEnv, isGaoDeMpEnv, isTCQMEAppEnv, isMpEnv, isTongchengAppEnv, isTEAppEnv }
 */
export function getPlatform() {
    var ua = window.navigator.userAgent.toLowerCase();
    // 途家
    var isTujiaAppEnv = /tujia/.test(ua);
    // 携程
    var isCtripAppEnv = /ctrip/.test(ua);
    // 去哪儿
    var isQunarAppEnv = /qunar/.test(ua);
    // 蚂蚁
    var isMayiAppEnv = /mayi/.test(ua);
    // 艺龙
    var isElongAppEnv = /ewandroid|ewiphone/.test(ua);
    // 同程
    var isTongchengAppEnv = /tctravel/.test(ua);
    // 京东
    var isJdAppEnv = /jdapp/.test(ua);
    // 微信
    var isWxEnv = /micromessenger/.test(ua);
    // 微信小程序
    var isWxMpEnv = isWxEnv &&
        (/miniprogram/.test(ua) || window.__wxjs_environment === 'miniprogram');
    // 阿里
    var isAliEnv = /alipayclient/.test(ua);
    // 阿里小程序
    var isAliMpEnv = isAliEnv && (/miniprogram/.test(ua) || /alipayidei/.test(ua));
    // 高德小程序 -- 目前高德只用于小程序业务
    var isGaoDeMpEnv = /amapclient/.test(ua);
    // 头条
    var isTouTiaoMpEnv = /toutiaomicroapp/.test(ua);
    // 百度小米浏览器
    var isMiBaiduBrower = /swan-mibrowser/.test(ua);
    // 百度小程序
    var isBaiduMpEnv = /swan/.test(ua) && !isMiBaiduBrower;
    // 快手小程序
    var isKuaiShouMpEnv = /kuaishou|快手开发者工具/.test(ua);
    // 携程通app
    var isCtripTongAppEnv = /cbp_wireless/.test(ua);
    // 四方APP
    var isTCQMEAppEnv = isTujiaAppEnv ||
        isCtripAppEnv ||
        isQunarAppEnv ||
        isMayiAppEnv ||
        isElongAppEnv ||
        isTongchengAppEnv ||
        isCtripTongAppEnv;
    var isMpEnv = isWxMpEnv ||
        isAliEnv ||
        isBaiduMpEnv ||
        isTouTiaoMpEnv ||
        isGaoDeMpEnv ||
        isKuaiShouMpEnv;
    var isWxBrowser = isWxEnv && !isWxMpEnv;
    var isBrowserEnv = !isTCQMEAppEnv && !isMpEnv;
    var isTEAppEnv = isElongAppEnv || isTongchengAppEnv;
    return {
        // 途家 APP
        isTujiaAppEnv: isTujiaAppEnv,
        // 携程 APP
        isCtripAppEnv: isCtripAppEnv,
        // 去哪儿 APP
        isQunarAppEnv: isQunarAppEnv,
        // 蚂蚁 APP
        isMayiAppEnv: isMayiAppEnv,
        // 艺龙 APP
        isElongAppEnv: isElongAppEnv,
        // 同程 APP
        isTongchengAppEnv: isTongchengAppEnv,
        // 同程或艺龙
        isTEAppEnv: isTEAppEnv,
        // 京东 APP
        isJdAppEnv: isJdAppEnv,
        // 微信环境
        isWxEnv: isWxEnv,
        // 支付宝环境
        isAliEnv: isAliEnv,
        // 微信小程序
        isWxMpEnv: isWxMpEnv,
        // 支付宝小程序
        isAliMpEnv: isAliMpEnv,
        // 百度小程序
        isBaiduMpEnv: isBaiduMpEnv,
        // 头条小程序
        isTouTiaoMpEnv: isTouTiaoMpEnv,
        // 高德小程序
        isGaoDeMpEnv: isGaoDeMpEnv,
        // 快手小程序
        isKuaiShouMpEnv: isKuaiShouMpEnv,
        // 四方 APP
        isTCQMEAppEnv: isTCQMEAppEnv,
        // 小程序
        isMpEnv: isMpEnv,
        // 微信普通浏览器 排除小程序场景
        isWxBrowser: isWxBrowser,
        // 普通浏览器环境 -- 包含微信浏览器
        isBrowserEnv: isBrowserEnv,
        // 携程通app
        isCtripTongAppEnv: isCtripTongAppEnv,
        // 携程通H5环境
        get isCtripTongH5Env() {
            return isInCtripTongH5Codes();
        },
        // 途家快应用小程序
        get isQuickMpEnv() {
            return getTujiaQuickEnv();
        },
        // 获取平台值
        get platformValue() {
            if (isTCQMEAppEnv || isJdAppEnv) {
                if (isTujiaAppEnv) {
                    return 'tujiaApp';
                }
                else if (isCtripAppEnv) {
                    return 'ctripApp';
                }
                else if (isQunarAppEnv) {
                    return 'qunarApp';
                }
                else if (isMayiAppEnv) {
                    return 'mayiApp';
                }
                else if (isElongAppEnv) {
                    return 'elongApp';
                }
                else if (isTongchengAppEnv) {
                    return 'tongchengApp';
                }
                else if (isJdAppEnv) {
                    return 'jdApp';
                }
                else if (isCtripTongAppEnv) {
                    return 'ctripTongApp';
                }
            }
            else if (isMpEnv) {
                if (isWxMpEnv) {
                    return 'wxMp';
                }
                else if (isAliEnv) {
                    return 'aliMp';
                }
                else if (isBaiduMpEnv) {
                    return 'baiduMp';
                }
                else if (isTouTiaoMpEnv) {
                    return 'ttMp';
                }
                else if (isGaoDeMpEnv) {
                    return 'gaodeMp';
                }
            }
            else if (isWxBrowser) {
                return 'wxBrowser';
            }
            else {
                return 'browser';
            }
        }
    };
}
// 获取途家快应用小程序
function getTujiaQuickEnv() {
    var TUJIA_QUICK_MP_LOCAL_KEY = '_quickmp';
    if (window.location.search
        .toLowerCase()
        .indexOf(TUJIA_QUICK_MP_LOCAL_KEY + "=true") > -1) {
        setLocalStorage(TUJIA_QUICK_MP_LOCAL_KEY, 'true');
        return true;
    }
    else {
        return getLocalStorage(TUJIA_QUICK_MP_LOCAL_KEY) === 'true';
    }
}
// 获取携程通H5所在环境:根据链接的code存在缓存里的值来判断。因为支付后会跳转到其他域名，再返回此链接时不带cookie，故将code存放在storage中
// 携程通H5需要隐藏头部
function isInCtripTongH5Codes() {
    var CTRIPTONGH5CODES = ['ctrip_tong_home']; // 若cookie或Storage中的tujiaCode在此常量数组中，即为此环境~
    var tujiaCode = tjCookie.getTujiaCode() || '';
    var tujiaCodeInLocalStorage = getLocalStorage('ctrip_tong');
    if (tujiaCode !== '') {
        setLocalStorage('ctrip_tong', { tujiaCode: tujiaCode });
    }
    if (CTRIPTONGH5CODES.includes(tujiaCode) ||
        CTRIPTONGH5CODES.includes(tujiaCodeInLocalStorage === null || tujiaCodeInLocalStorage === void 0 ? void 0 : tujiaCodeInLocalStorage.tujiaCode)) {
        return true;
    }
    else {
        return false;
    }
}
